import { StarIcon as StarIconSolid } from "@heroicons/react/24/solid";
import { StarIcon as StarIconOutline } from "@heroicons/react/24/outline";

type Props = {
  /** null renders the "Not observed" pill instead of stars. */
  level: number | null;
  size?: "sm" | "md";
};

/**
 * Read-only star rendering of a competency level, matching the interactive rating
 * control in CompetencyScoreCard so a score looks the same whether you're giving it or
 * reviewing it later - in the merge/detail views, on someone else's evaluation, etc.
 */
export default function StarRatingDisplay({ level, size = "sm" }: Props) {
  if (level === null) {
    return (
      <span className="inline-flex items-center rounded-full bg-gray-100 dark:bg-slate-700 px-2 py-0.5 text-xs font-medium text-gray-500 dark:text-gray-400">
        Not observed
      </span>
    );
  }

  const starSize = size === "sm" ? "h-4 w-4" : "h-5 w-5";

  return (
    <div className="flex items-center gap-2">
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((i) => {
          const Icon = i <= level ? StarIconSolid : StarIconOutline;
          return (
            <Icon
              key={i}
              className={`${starSize} ${
                i <= level ? "text-amber-400" : "text-gray-300 dark:text-gray-600"
              }`}
            />
          );
        })}
      </div>
      <span className="text-sm font-semibold text-gray-700 dark:text-gray-200">
        {level}/5
      </span>
    </div>
  );
}
